import { makeStyles } from "@material-ui/styles";
import { red } from "@material-ui/core/colors";
import { createMuiTheme } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

export default makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        // width: 500,
    },
    searchRoot: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        //   width: 400,
        marginBottom: '10px'
    },
    searchInput: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    searchIconButton: {
        padding: 10,
    },
    searchDivider: {
        height: 28,
        margin: 4,
    },
    listitemicon: {
        minWidth: 30
    },
    listitem: {
        //padding: '1px',
        padding: "3px 1px 2px 5px",
        margin: "3px 1px 2px 0px",
        border:"1px solid rgba(56, 193, 239, 0.5)",
        '&:hover':{
            backgroundColor: fade(theme.palette.primary.main, 0.08),
        }
    },
    cstmgridadd:{
        paddingRight:"4px",
    },
    dashletLink: {
        textDecoration: 'none !important'
    },
    dialogPaper: {
        minHeight: '80vh',
        // maxHeight: '80vh',
    },
    whitetextcolor:{
        color:'#ffffff',
    },
}));


export const getMuiTheme = (theme) => {
    return createMuiTheme({
      ...theme,
      overrides: {
        MuiTypography:{
            body1:{
                fontSize:"0.9rem",
                color:"#000!important"
            }
        }
        
      },
    });
  }
